var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"value":_vm.search,"prepend-icon":"mdi-account-search","label":_vm.label,"single-line":"","hide-details":""},on:{"input":function (event) { return _vm.$emit('update:search', event); }}})}
var staticRenderFns = []

export { render, staticRenderFns }